<div class="wrapper">
  <span>{{ brand }}</span>
</div>
